export { default } from './GroupsSearchCollector';



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchCollector/index.js